import { getUTCDate } from '@/shared/utils/date';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { MobileRow, MobileRowTitle, MobileRowValue, MobileTableRowWrap } from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../../types';

interface MobileTableProps {
  tableData: TransformedAssetClassForecastValueDto[];
}

interface AllocationSummary {
  [year: string]: number;
}

const MobileSumFooter = ({ tableData }: MobileTableProps) => {
  const dateAllocations: AllocationSummary = {};

  const addAllocation = (date: string, allocation: number) => {
    const year = getUTCDate(new Date(date)).toUpperCase();

    if (!dateAllocations[year]) {
      dateAllocations[year] = 0;
    }
    dateAllocations[year] += allocation;
  };

  tableData.forEach((assetClass) => {
    assetClass.values.forEach((allocation) => {
      addAllocation(allocation.date, allocation.value);
    });
  });

  return (
    <MobileSumFooterWrap>
      <MobileRow>
        <MobileRowTitle>Total</MobileRowTitle>
      </MobileRow>

      {Object.entries(dateAllocations).map(([year, value]) => (
        <MobileRow key={year}>
          <MobileRowTitle>{year}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{value}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      ))}
    </MobileSumFooterWrap>
  );
};

const MobileSumFooterWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer[2]};
`;

export default MobileSumFooter;
